<!-- 兑换记录 -->
<template>
  <div class="content" style="padding: 0;height: 100%">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      size="small"
      style="margin-left: 20px;margin-top: 10px"
    >
      <el-form-item label="支付状态">
        <el-select
          v-model="formInline.pay_status"
          placeholder="选择"
          clearable
          @change="getOrderList"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="已支付" value="1"></el-option>
          <el-option label="未支付" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-date-picker
          style="width: 185px"
          v-model="date1"
          type="datetime"
          placeholder="选择日期时间"
          align="right"
          :picker-options="pickerOptions"
          @change="Date1"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
          style="width: 185px"
          v-model="date2"
          type="datetime"
          placeholder="选择日期时间"
          align="right"
          :picker-options="pickerOptions"
          @change="Date2"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="cxlist">查询</el-button>
        <el-button type="primary" @click="exportOrder">导出订单</el-button>
      </el-form-item>
    </el-form>
    <el-card style="margin: 10px auto;width: 95%;margin-right: 4%;">
      <div style=" display: flex;justify-content: space-around">
        <div>
          <div style="font-size: 18px;margin-bottom: 10px">总订单数</div>
          <div style="text-align: center;font-size: 16px">
            {{ statistics_info.total_num }}
          </div>
        </div>
        <div>
          <div style="font-size: 18px;margin-bottom: 10px">现金</div>
          <div style="text-align: center;font-size: 16px">
            ¥{{ Math.round(Number(statistics_info.cash) * 100) / 100 }}
          </div>
        </div>
        <div>
          <div style="font-size: 18px;margin-bottom: 10px">支付宝</div>
          <div style="text-align: center;font-size: 16px">
            ¥{{ Math.round(Number(statistics_info.alipay) * 100) / 100 }}
          </div>
        </div>
        <div>
          <div style="font-size: 18px;margin-bottom: 10px">微信</div>
          <div style="text-align: center;font-size: 16px">
            ¥{{ Math.round(Number(statistics_info.wxpay) * 100) / 100 }}
          </div>
        </div>
        <div>
          <div style="font-size: 18px;margin-bottom: 10px">银联</div>
          <div style="text-align: center;font-size: 16px">
            ¥{{ Math.round(Number(statistics_info.unionpay) * 100) / 100 }}
          </div>
        </div>
        <div>
          <div style="font-size: 18px;margin-bottom: 10px">闪付</div>
          <div style="text-align: center;font-size: 16px">
            ¥{{ Math.round(Number(statistics_info.fuiou) * 100) / 100 }}
          </div>
        </div>
        <div>
          <div style="font-size: 18px;margin-bottom: 10px">总支付金额</div>
          <div style="text-align: center;font-size: 16px">
            ¥{{ Math.round(Number(statistics_info.total_amount) * 100) / 100 }}
          </div>
        </div>
        <div>
          <div style="font-size: 18px;margin-bottom: 10px">获得总利润</div>
          <div style="text-align: center;font-size: 16px">
            ¥{{ Math.round(Number(statistics_info.profit) * 100) / 100 }}
          </div>
        </div>
      </div>
    </el-card>
    <el-table :data="tableData" border style="width: 95%;margin: 10px auto;margin-right: 4%;">
      <el-table-column prop="order_sn" label="编号" align="center">
      </el-table-column>
      <el-table-column prop="goods.url" label="图片" align="center">
        <template slot-scope="scope">
          <img
            style="width: 50px;height: 50px;"
            :src="
              scope.row.goods.url == ''
                ? scope.row.goods.logo
                : scope.row.goods.url
            "
          />
        </template>
      </el-table-column>
      <el-table-column prop="goods.title" label="商品" align="center">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.goods.title }}</span>
            <span> x{{ scope.row.num }}</span>
          </div>
          <div v-if="scope.row.goods.alliance_goods != 0">
            <el-tag size="mini">联盟商品</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="goods.money"
        label="商品单价"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="goods.price"
        label="商品进价"
        align="center"
      ></el-table-column>
      
      <el-table-column prop="address" label="会员" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.info">
            <div>{{ scope.row.info.username }}</div>
          </div>
          <div v-else>
            暂无购买人信息
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="支付金额" align="center">
        <template slot-scope="scope">
          <span style="color: red">¥{{ scope.row.total_money }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="profit"
        label="可得利润"
        align="center"
      ></el-table-column>
      <el-table-column prop="address" label="订单时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.pay_status == 1"
            >已支付</el-tag
          >
          <el-tag type="danger" v-else>未支付</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="show_payment" label="支付方式" align="center">
      </el-table-column>
      <el-table-column prop="address" label="支付时间" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1 && scope.row.consume_time !== 0">
            {{ scope.row.consume_time | dataFormat }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="print_order(scope.row.id)"
            >打印小票</el-button
          >
          <el-button
            type="text"
            size="mini"
            style="margin: 0;"
            @click="handleDelete(scope.row.id)"
            >删除订单</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-left: 10px"
      @current-change="handleCurrentChange"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="total_num"
    ></el-pagination>

    <shipments
      :showDialog="showDialog"
      :formData="formData"
      @close="close"
    ></shipments>
    <!-- 核销 -->
    <el-dialog :visible.sync="verifiyFormVisible"></el-dialog>
  </div>
</template>

<script>
import { selectStoreList } from "@/api/storeManage";
import { exportMethods } from "@/api/vip";
import shipments from "@/views/apply/comModule/integralMall/order/shipments";
import { orderDelete } from "@/api/integralMall";
import { convenience_store_index, statistics,print_credit_order } from "@/api/order";
import { mapGetters } from "vuex";
import paywayList from "@/utils/payment_code";

export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["app_id", "token"]),
    getstart_time: function() {
      return this.formInline.start_time;
    },
    getend_time: function() {
      return this.formInline.end_time;
    }
  },
  data() {
    return {
      paywayList: paywayList,
      emp: true,
      end_time: true,
      date1: "",
      pageSize:5,
      date2: "",
      tableData: [
        {
          order_sn: "",
          status: "",
          num: "",
          id: "",
          goods: {
            title: "",
            logo: "",
            alliance_goods: ""
          },
          info: {
            username: ""
          },
          create_time: ""
        }
      ],
      page: "1",
      total_num: 0,
      screenInput: "",
      data: [],
      showDialog: false,
      formData: {
        address: {
          name: "",
          mobile: "",
          area_name: "",
          address: ""
        }
      },
      formInline: {
        start_time: '',
        end_time: '',
        pay_status: ''
      },
      shopLists: [],
      verifiyFormVisible: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          },
          {
            text: "三个月前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 3 * 30);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      statistics_info: {}
    };
  },
  watch: {},
  components: {
    shipments
  },
  created() {
    this.getOrderList();
    this.getShopList(); //门店列表
  },
  methods: {
    //小票打印
    async print_order(id){
      const res = await print_credit_order({
        app_id:this.app_id,
        id:id
      })
      if(res.code == 200){
        this.$message.success(res.msg)
      }
    },
    getShopList() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      selectStoreList(data).then(res => {
        console.log("门店下拉列表", res);
        this.shopLists = res.data;
      });
    },
    // 发货
    deliverGoods(item) {
      this.showDialog = true;
      this.formData = item;
    },
    close() {
      this.showDialog = false;
      this.reload();
    },
    Date1(val) {
      console.log('kaishi',val);
      if (val == null) {
        this.formInline.start_time = "";
        this.getOrderList();
      } else {
        this.formInline.start_time = val.getTime();
      }
    },
    Date2(val) {
      console.log(val);
      if (val == null) {
        this.formInline.end_time = "";
        this.getOrderList();
      } else {
        this.formInline.end_time = val.getTime();
      }
    },
    // 获取列表
    cxlist() {
      if (this.formInline.start_time && this.formInline.end_time) {
        console.log(this.formInline.start_time, this.formInline.end_time);
        let res = this.formInline.start_time - this.formInline.end_time;
        if (res > 0) {
          this.$message.error("请确定选择结束日期不能位于开始日期之前");
          this.formInline.start_time = "";
          this.formInline.end_time = "";
          this.date1 = "";
          this.date2 = "";
        } else {
          this.getOrderList();
        }
      }
    },
    getOrderList() {
      let data = {
        app_id: this.app_id,
        page: this.page,
        ...this.formInline
      };
      convenience_store_index(data).then(res => {
        console.log("订单列表", res);
        if (res.code == 200) {
          var data = res.data.result;
          // data.consume_time = time(res.data.result.consume_time)
          for (var k in data) {
            if (data[k].goods == null) {
              let obj = {};
              obj.logo = "";
              obj.title = "";
              data[k].goods = obj;
            }
          }
          data.forEach(item => {
            if (!item.emp_info || item.emp_info.length == 0) {
              item.emp_info = null;
            }
            item.goods.price = item.goods.price?item.goods.price:"0.00"
            // console.log(item)
            if (item.payment_code != "") {
              // debugger
              item.show_payment = this.paywayList.find(
                x => x.id == item.payment_code
              ).name;
              console.log(item.show_payment);
            } else {
              item.show_payment = "";
            }
          });
          console.log(data);
          this.tableData = data;
          this.total_num = res.data.total_num;
          this.pageSize = res.data.num
          if (data.length <= 0) {
            this.$message.info("没有更多了");
          }
          this.get_orderstatistics();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //订单统计
    get_orderstatistics() {
      let data = {
        app_id: this.app_id,
        page: this.page,
        ...this.formInline
      };
      statistics(data).then(res => {
        if (res.code == 200) {
          this.statistics_info = res.data;
        }
      });
    },
    // 删除订单
    handleDelete(id) {
      console.log("--------");
      console.log(id);
      this.$confirm("此操作永久删除该商品，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async res => {
          const data = await orderDelete({
            id: id
          });
          console.log(data);
          this.getOrderList();
          if (data.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功！"
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getOrderList();
    },
    exportOrder() {
        if(this.formInline.start_time&&this.formInline.end_time){
          if(this.formInline.end_time<this.formInline.start_time){
            return this.$message.error('开始时间不能大于结束时间')
          }
        }
        this.$confirm("确定要导出吗？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let data = {
              Api: "creditshop/agent.creditshop_goods_order/convenience_store_export",
              app_id: this.app_id,
              params: [
                { name: "token", value: this.token },
                { name: "start_time", value: this.formInline.start_time },
                { name: "end_time", value: this.formInline.end_time },
                {name:"pay_status",value: this.formInline.pay_status}
              ]
            };
            exportMethods(data);
          })
          .catch(e => {
            this.date1 = ''
            this.date2 = ''
            this.formInline.start_time = "";
            this.formInline.end_time = "";
            console.log(e);
          });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../../public/style/_interfacePublic";
.flex {
  display: flex;
  align-items: center;
}
.detail {
  display: flex;
  justify-content: space-between;
}
.padding {
  padding: 20px;
}
.content {
  width: 100%;
}
</style>
